import type { Types as SduiTypes } from '../types';
import type { OutTypes } from './schedules';

export default (
  group: SduiTypes.classes
): OutTypes.group => {
  return {
    ids: group.id
  };
};
